import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { Cmg1003GmiState, Cmg1003GmiStore } from './gmi.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class Cmg1003GmiQuery extends QueryEntity<Cmg1003GmiState> {
  protected store: Cmg1003GmiStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(Cmg1003GmiStore);

    super(store);

    this.store = store;
  }

  getValueByBorrowerIds(borrowerIds: number[]) {
    return this.getAll({
      filterBy: (t) => borrowerIds.some((b) => t.borrowerId === b),
    });
  }
}
